import { Reducer, AnyAction } from 'redux';
import { Invoice } from '../constants/invoice';

export interface InvoiceState {
  loading: boolean;
}

export const initialState: InvoiceState = {
  loading: true,
};

export const invoicesReducer: Reducer<InvoiceState> = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case 'LOAD_INVOICE_PAGING':
      return { ...state, invoiceList: [...action.payload], loading: true };
    case 'RESET_LOADED_INVOICE':
      return initialState;
    case 'LOAD_INVOICE_PENDING':
      return initialState;
    case 'GENERATE_ROTP_TOKEN_SUCCESS':
      return initialState;
    default:
      return state;
  }
};
